import React from 'react';
import Modal from 'components/UI/Modal';
import CloseButton from 'components/UI/CloseButton';
import Image from 'components/UI/Image';

import * as styles from './ImageModal.module.scss';

export default function ImageModal({
  img: { desktop_2x, desktop_webp_2x, desktop, desktop_webp, alt },
  ...props
}) {
  return (
    <Modal
      closeButton={false}
      containerMod="imageModal"
      contentMod="withoutMarginMobile"
      {...props}
    >
      {onClose => (
        <div className={styles.content}>
          <CloseButton className={styles.closeButton} onClose={onClose} />
          <div className={styles.pictureWrapper}>
            <Image
              className={styles.picture}
              classImage={styles.image}
              src={{ desktop_2x, desktop_webp_2x, desktop, desktop_webp }}
              alt={alt ?? 'Visual concept'}
            />
          </div>
        </div>
      )}
    </Modal>
  );
}
